import axios from "axios";
import { getConfig } from "common/config";
import {
  applyCustomerContextHeaders,
  attachCustomerHeaderOmissionInterceptor,
  clearCustomerContextHeaders,
} from "./CustomerContextHeaders";
import {
  applyRequestAuthHeader,
  createUnauthorizedResponseHandler,
} from "./httpAuthInterceptors";

const base_url = getConfig("REACT_APP_BASE_URL");

const httpClientPAdmin = axios.create({
  baseURL: base_url,
  responseType: "json",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

const setDefaultAuthorization = (token) => {
  httpClientPAdmin.defaults.headers.common.Authorization = `Bearer ${token}`;
};

httpClientPAdmin.interceptors.request.use(
  (config) => applyRequestAuthHeader(config, setDefaultAuthorization),
  (error) => Promise.reject(error)
);

attachCustomerHeaderOmissionInterceptor(httpClientPAdmin);

httpClientPAdmin.interceptors.response.use(
  (response) => response,
  createUnauthorizedResponseHandler(httpClientPAdmin, setDefaultAuthorization)
);

const setAuthTokenPAdmin = (token) => {
  if (!token) {
    delete httpClientPAdmin.defaults.headers.common.Authorization;
    clearCustomerContextHeaders();
    return;
  }
  httpClientPAdmin.defaults.headers.common.Authorization = `Bearer ${token}`;
};

const setTokenToHeaderPAdmin = (userid, token, customerCode) => {
  setAuthTokenPAdmin(token);
  if (!token) {
    return;
  }
  if (customerCode != null && String(customerCode).trim() !== "" && userid) {
    applyCustomerContextHeaders(userid, customerCode);
  } else {
    clearCustomerContextHeaders();
  }
};

const changeHeaderTokenPAdmin = (userId, customerCode) => {
  if (customerCode == null || String(customerCode).trim() === "") {
    clearCustomerContextHeaders();
    return;
  }
  const resolvedUserId =
    userId ?? httpClientPAdmin.defaults.headers.common["user-id"];
  applyCustomerContextHeaders(resolvedUserId, customerCode);
};

export {
  httpClientPAdmin,
  setAuthTokenPAdmin,
  setTokenToHeaderPAdmin,
  changeHeaderTokenPAdmin,
  base_url,
};
